export function lock(cb) {
  let disable = false;
  return async (...arg) => {
    if (disable) {
      return;
    }
    try {
      disable = true;
      const res = await cb(...arg);
      return res;
    } finally {
      disable = false;
    }
  };
}
